var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVApps05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3068_81838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3874 7.26074H4.88147",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3262 31.9906V40.8713C45.3262 41.9194 44.4765 42.769 43.4284 42.769H2.5716C1.52348 42.769 0.673828 41.9194 0.673828 40.8713V5.12892C0.673828 4.0808 1.52348 3.23115 2.5716 3.23115H43.4284C44.4765 3.23115 45.3262 4.0808 45.3262 5.12892V28.8404",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26862 11.2905H45.3262",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.673828 11.2905H3.11848",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9797 7.26382C40.9797 8.16756 40.2471 8.90015 39.3434 8.90015C38.4397 8.90015 37.7071 8.16756 37.7071 7.26382C37.7071 6.36008 38.4397 5.6275 39.3434 5.6275C40.2471 5.6275 40.9797 6.36008 40.9797 7.26382Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4182 7.26382C34.4182 8.16756 33.6856 8.90015 32.7818 8.90015C31.8782 8.90015 31.1455 8.16756 31.1455 7.26382C31.1455 6.36008 31.8782 5.6275 32.7818 5.6275C33.6856 5.6275 34.4182 6.36008 34.4182 7.26382Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5752 19.9878H41.3064",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0512 19.9878H28.941",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4167 26.8823H41.3064",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0512 26.8823H36.7825",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5752 33.7769H41.3064",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0512 33.7769H28.941",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2581 21.9077C29.5307 21.9077 28.941 21.3181 28.941 20.5906V19.3084C28.941 18.581 29.5307 17.9912 30.2581 17.9912C30.9855 17.9912 31.5751 18.581 31.5751 19.3084V20.5906C31.5751 21.3181 30.9855 21.9077 30.2581 21.9077Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0996 28.8403C37.3722 28.8403 36.7825 28.2507 36.7825 27.5232V26.241C36.7825 25.5136 37.3722 24.9239 38.0996 24.9239C38.827 24.9239 39.4167 25.5136 39.4167 26.241V27.5232C39.4167 28.2507 38.827 28.8403 38.0996 28.8403Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2581 35.7349C29.5307 35.7349 28.941 35.1452 28.941 34.4178V33.1355C28.941 32.4081 29.5307 31.8185 30.2581 31.8185C30.9855 31.8185 31.5751 32.4081 31.5751 33.1355V34.4178C31.5751 35.1452 30.9855 35.7349 30.2581 35.7349Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5654 31.1178C11.2156 31.1178 9.31061 29.2128 9.31061 26.863C9.31061 24.5131 11.2156 22.6082 13.5654 22.6082C15.9152 22.6082 17.8202 24.5131 17.8202 26.863C17.8202 29.2128 15.9152 31.1178 13.5654 31.1178ZM21.8794 25.4831H21.3871C21.1295 25.4831 20.9071 25.3062 20.8452 25.0562C20.6631 24.3199 20.3723 23.6266 19.9907 22.9942C19.8574 22.7733 19.8892 22.4907 20.0716 22.3083L20.4201 21.9598C20.6379 21.742 20.6379 21.3888 20.4201 21.1709L19.2574 20.0083C19.0396 19.7905 18.6864 19.7905 18.4686 20.0083L18.1201 20.3568C17.9377 20.5392 17.6551 20.571 17.4343 20.4377C16.8017 20.0561 16.1085 19.7653 15.3721 19.5831C15.1221 19.5213 14.9453 19.2988 14.9453 19.0413V18.549C14.9453 18.2408 14.6955 17.9912 14.3874 17.9912H12.7434C12.4353 17.9912 12.1855 18.2408 12.1855 18.549V19.0413C12.1855 19.2988 12.0087 19.5213 11.7587 19.5831C11.0223 19.7653 10.3291 20.0561 9.69658 20.4377C9.47566 20.571 9.1931 20.5392 9.01071 20.3568L8.66221 20.0083C8.44434 19.7905 8.09116 19.7905 7.87338 20.0083L6.71071 21.1709C6.49293 21.3888 6.49293 21.742 6.71071 21.9598L7.05922 22.3083C7.2416 22.4907 7.2735 22.7733 7.14017 22.9942C6.75851 23.6266 6.46769 24.3199 6.28557 25.0562C6.22367 25.3062 6.00131 25.4831 5.74364 25.4831H5.25138C4.94322 25.4831 4.69354 25.7328 4.69354 26.0409V27.685C4.69354 27.9931 4.94322 28.2429 5.25138 28.2429H5.74364C6.00131 28.2429 6.22367 28.4197 6.28557 28.6697C6.46769 29.406 6.75851 30.0993 7.14017 30.7318C7.2735 30.9527 7.2416 31.2353 7.05922 31.4177L6.71071 31.7662C6.49293 31.9841 6.49293 32.3372 6.71071 32.555L7.87338 33.7176C8.09116 33.9355 8.44434 33.9355 8.66221 33.7176L9.01071 33.3692C9.1931 33.1867 9.47566 33.1549 9.69658 33.2882C10.3291 33.6699 11.0223 33.9607 11.7587 34.1428C12.0087 34.2046 12.1855 34.4271 12.1855 34.6848V35.177C12.1855 35.4851 12.4353 35.7349 12.7434 35.7349H14.3874C14.6955 35.7349 14.9453 35.4851 14.9453 35.177V34.6848C14.9453 34.4271 15.1221 34.2046 15.3721 34.1428C16.1085 33.9607 16.8017 33.6699 17.4343 33.2882C17.6551 33.1549 17.9377 33.1867 18.1201 33.3692L18.4686 33.7176C18.6864 33.9355 19.0396 33.9355 19.2574 33.7176L20.4201 32.555C20.6379 32.3372 20.6379 31.9841 20.4201 31.7662L20.0716 31.4177C19.8892 31.2353 19.8574 30.9527 19.9907 30.7318C20.3723 30.0993 20.6631 29.406 20.8452 28.6697C20.9071 28.4197 21.1295 28.2429 21.3871 28.2429H21.8794C22.1876 28.2429 22.4372 27.9931 22.4372 27.685V26.0409C22.4372 25.7328 22.1876 25.4831 21.8794 25.4831V25.4831Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3068_81838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVApps05);
export default __webpack_public_path__ + "static/media/vApps05.3f9681a437e6ed568836a4202685891c.svg";
export { ForwardRef as ReactComponent };